import { render, staticRenderFns } from "./form-page.vue?vue&type=template&id=72f11c08&scoped=true"
import script from "./form-page.vue?vue&type=script&lang=js"
export * from "./form-page.vue?vue&type=script&lang=js"
import style0 from "./form-page.vue?vue&type=style&index=0&id=72f11c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f11c08",
  null
  
)

export default component.exports